<div class="product-detail__mobile">
  <div>
    <div class="flex justify-center" *ngIf="!productInfo?.images?.length">
      <img  src="assets/picture.svg" class="picture h-[14rem]" />
    </div>   
    <nz-carousel *ngIf="productInfo?.images?.length > 0">
      <div 
        nz-carousel-content 
        *ngFor="let item of productInfo?.images; let i = index">
        <div class="flex justify-center">
          <img [src]="item.imageURL800" class="h-[14rem]"/>
        </div>
      </div>

    </nz-carousel>
    <div class="product-header">
      <div class="status-tag-box">
        <span [ngClass]="['status-tag',  productInfo.misc?.articleStatusDescription === '在售' ? 'success' : '' ]">{{ productInfo.misc?.articleStatusDescription }}</span>

        <span class="status-tag danger" *ngIf="productInfo?.stockQty === 0">{{'NO_STOCK' | translate }}</span>
        <span class="status-tag success" *ngIf="productInfo?.stockQty > 0 && productInfo?.quantity <= productInfo?.stockQty">{{'IN_STOCK' | translate }}</span>
        <span class="status-tag waring" *ngIf="productInfo?.stockQty > 0 && productInfo?.quantity > productInfo?.stockQty">{{'LOW_STOCK' | translate }}</span>
      </div>
      <div class="product-title">{{ productInfo?.genericArticles?.[0]?.genericArticleDescription }}</div>
      <div class="product-number">{{productInfo?.articleNumber}}</div>
    </div>
  </div>
  <div class="product-body">
    <div class="product-no product-card">
      <div class="product-detail-title">
        <div class="title">{{'PRODUCT_NO' | translate }}</div>
      </div>
      <div class="mb-4">
        <span class="product-no__label">{{'TRADE_NUMBER' | translate }} </span>
        <span 
          class="product-no__trade" 
          *ngFor="let trade of productInfo?.tradeNumbers;let last = last" 
          (click)="goSearch(trade)"
        >
          {{ trade }}{{ !last ? ' / ' : '' }}
        </span>
        <span *ngIf="!productInfo?.tradeNumbers?.length" class="product-no__trade">
           -- 
        </span>
      </div>
      <div class="mb-4">
        <span class="product-no__label">{{'REPLACES' | translate }}</span>
        <span *ngIf="!productInfo?.replacesArticles?.length" class="product-no__trade">--</span>
        <div *ngIf="productInfo?.replacesArticles?.length > 0">
          <span 
            class="product-no__item" 
            *ngFor="let replaces of productInfo?.replacesArticles;" 
            (click)="goSearch(replaces.articleNumber)"
          >
            {{ replaces.articleNumber }}
          </span>
        </div>
      </div>
      <div class="">
        <span class="product-no__label">{{'REPLACED_BY' | translate }}</span>
        <span *ngIf="!productInfo?.replacedByArticles?.length" class="product-no__trade">--</span>
        <div *ngIf="productInfo?.replacedByArticles?.length > 0">
          <span 
            class="product-no__item" 
            *ngFor="let replaced of productInfo?.replacedByArticles;" 
            (click)="goSearch(replaced.articleNumber)"
          >
            {{replaced.articleNumber}}
          </span>
        </div>
      </div>
    </div>
    <div class="product-linkage product-card">
      <div class="product-detail-title">
        <div class="title">{{'VEHICLE_LINKAGE' | translate }}</div>
        <div class="extra" (click)="handleViewAllBrand()">
          <span class="color-blue pr-1">{{'SEE_ALL' | translate }}</span> 
          <i nz-icon nzType="right" nzTheme="outline" class="color-blue"></i>
        </div>
      </div>
      <div class="brand-collapse">
        <div class="brand-collapse__item" *ngFor="let item of vehicles?.slice(0,3)" >
          <div class="brand-collapse__header" (click)="handleViewAllBrand()">
              <span class="brand-name">{{ item.manuName }}</span>
              <i nz-icon nzType="right" nzTheme="outline"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="product-criteria product-card" *ngIf="mergedCriteria?.length>0">
      <div class="product-detail-title">
        <div class="title">{{'CRITERIA' | translate }}</div>
      </div>
      <div class="criteria-item" *ngFor="let criteria of mergedCriteria">
        <div class="flex items-center">
          <svg-icon [iconName]="'new/arrows-x-y-z.svg'" class="mr-2"></svg-icon>
          <span class="font-bold">{{criteria.criteriaAbbrDescription}}</span>
        </div>
        <span>{{criteria.formattedValue}} {{criteria.criteriaUnitDescription}}</span>
      </div>
    </div>
    <div class="product-oe product-card" *ngIf="mfrNameOptions?.length > 0">
      <div class="product-detail-title">
        <div class="title">{{'OE_NUMBER' | translate }}</div>
        <nz-select 
          name="select-validate" 
          [ngModel]="mobileCarType" 
          [nzDropdownMatchSelectWidth]="false"
          (ngModelChange)="onCarTypeChange($event)"
          class="product-oe__select"
          [nzSuffixIcon]="suffixSearch"
        >
          <nz-option nzValue="" nzLabel="All Brands"></nz-option>
          <nz-option *ngFor="let item of mfrNameOptions; let i = index" [nzValue]="item" [nzLabel]="item"></nz-option>
          <ng-template #suffixSearch><i class="search-arrow"></i></ng-template>
        </nz-select>
      </div>
      <div class="brand-collapse">
        <div *ngFor="let mfr of mfrNameOptions">
          <div class="brand-collapse__item"  *ngIf="mfr === mobileCarType || !mobileCarType">
            <div class="brand-collapse__header" (click)="handleOpenCollapse(mfrNameMap[mfr])">
                <span class="brand-name">{{ mfr }}</span>
                <i nz-icon [nzType]="mfrNameMap[mfr].active ? 'up': 'down' " nzTheme="outline"></i>
            </div>
            <div [hidden]="!mfrNameMap[mfr].active"  class="brand-collapse__body">
              <div>
                <div 
                  class="brand-collapse__desc" 
                  *ngFor="let item of mfrNameMap[mfr]" 
                >
                  {{ item.articleNumber }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="product-detail__fixed"  [ngClass]="isScrollBottom ? 'relative': 'fixed left-0 bottom-0'">
    <div class="flex-row">
      <div>
        <span>{{'EXPECT_DATE' | translate }}</span>
        <nz-date-picker 
          *ngIf="productInfo?.quantity" 
          [nzAllowClear]="false" 
          [nzSuffixIcon]="suffixDate"  
          [(ngModel)]="productInfo.expectedDate" 
          [nzPlaceHolder]="'ADD_DATE'|translate"
          class="product-expected-date" 
          nzFormat="yyyy-MM-dd" 
          [nzShowToday]="false" 
          >
          <ng-template #suffixDate>
            <i nz-icon nzType="right" nzTheme="outline" style="color: #000"></i>
          </ng-template>
        </nz-date-picker>
      </div>

      <div class="quantity-number">
        <span class="minus" (click)="decrease(productInfo)">
            <span nz-icon nzType="minus" nzTheme="outline"></span>
        </span>
        <nz-input-number 
            class="quantity" 
            [(ngModel)]="productInfo.quantity" 
            [nzMin]="0"  
            [nzStep]="productInfo.minumQty"
            (nzBlur)="quantityBlur($event)"
        ></nz-input-number>
        <span class="plus" (click)="increase(productInfo)">
            <span nz-icon nzType="plus" nzTheme="outline"></span>
        </span>
      </div>
    </div>
       
    <div class="flex-row mb-4">
      <span >{{'MOQ' | translate}}:{{productInfo.minumQty}}</span>
    </div>
    <button 
      nz-button 
      nzSize="large" 
      nzType="primary"
     
      class="primary-mid-btn add-cart "
      [disabled]="!isLogin || userData?.queryUserPageInfoResDTO?.status !== 2" 
      (click)="addToCart(productInfo)"
      nzBlock
    >
      <svg-icon [isUrl]="false" [iconName]="'cart.svg'" class="mr6" [size]="20"></svg-icon>
      <span>{{'ADD_TO_CART' | translate }}</span>
    </button>
</div>


<nz-drawer
  [nzClosable]="false"
  [nzVisible]="brandListVisible"
  nzPlacement="bottom"
  (nzOnClose)="handleCloseDrawer()"
  nzHeight="100vh"
>
  <ng-container *nzDrawerContent>
    <div class="drawer-body">
      <div class="drawer-close" (click)="handleCloseDrawer()">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M12.7072 12L19.8536 19.1464L19.1465 19.8536L12.0001 12.7072L4.85364 19.8536L4.14648 19.1464L11.2929 12L4.14649 4.85358L4.85364 4.14642L12.0001 11.2928L19.1465 4.14642L19.8536 4.85358L12.7072 12Z" fill="black"/>
        </svg>
      </div>
      <div class="product-detail-title">
        <div class="title">{{'VEHICLE_LINKAGE' | translate }}</div>
      </div>

      <div class="brand-collapse">
        <div class="brand-collapse__item" *ngFor="let panel of brandList" >
          <div class="brand-collapse__header" (click)="handleOpenCollapse(panel)">
              <span class="brand-name">{{ panel.name }}</span>
              <i nz-icon [nzType]="panel.active ? 'up': 'down' " nzTheme="outline"></i>
          </div>
          <div [hidden]="!panel.active"  class="brand-collapse__body">
            <div >
              <div class="brand-collapse__desc" *ngFor="let item of panel.list" >{{ item.carDesc }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="fixed-button">
        <div class="confirm-button" (click)="handleCloseDrawer()">
          <i nz-icon nzType="check" nzTheme="outline"></i>
          {{'CONFIRM' | translate }}
        </div>
      </div>
    </div>
  </ng-container>
</nz-drawer>
  
